// BUILD-046 section B (Owner direction of 2026-10-21): the row of ACTIVE filters, below the toolbar, left-aligned, drawn only while a filter is on. Each badge removes only its own criterion; "Clear filters" removes the
// narrowing criteria and leaves the search, Status, sorting and display preferences alone. The count says tasks or requests and says "loaded" when the list is not whole (activeFilters.describeMatchCount).
import { focusToolbar } from './JobFilterChip';
import { CLEAR_FILTERS_LABEL } from './activeFilters';

export interface ActiveBadge {
  key: string;
  text: string;
  title?: string;
  removeLabel: string;
  onRemove: () => void;
}

export interface ActiveFiltersRowProps {
  badges: readonly ActiveBadge[];
  countText: string;
  /** The longer sentence ("3 of 42 loaded tasks match"), the count's hover text. Optional. */
  countTitle?: string;
  onClearAll: () => void;
}

export function ActiveFiltersRow({ badges, countText, countTitle, onClearAll }: ActiveFiltersRowProps) {
  if (badges.length === 0) return null;
  return (
    <div role="group" aria-label="Active filters" className="mb-3 flex flex-wrap items-center justify-start gap-2" data-testid="active-filters">
      {badges.map((badge) => (
        <span key={badge.key} title={badge.title} className="inline-flex max-w-full items-center gap-1 rounded-full border border-sky-200 bg-sky-50 py-0.5 pl-3 pr-1 text-xs text-gray-900" data-testid={"active-filter-" + badge.key}>
          <span className="min-w-0 break-words">{badge.text}</span>
          <button
            type="button"
            aria-label={badge.removeLabel}
            title={badge.removeLabel}
            onClick={() => {
              focusToolbar();
              badge.onRemove();
            }}
            className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-gray-700 hover:bg-sky-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2a7fb8]"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={() => {
          focusToolbar();
          onClearAll();
        }}
        className="rounded px-1 text-xs text-[#1f6a99] underline hover:bg-sky-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2a7fb8]"
        data-testid="clear-filters"
      >
        {CLEAR_FILTERS_LABEL}
      </button>
      <span role="status" aria-live="polite" title={countTitle} className="text-xs text-gray-600" data-testid="active-filters-count">
        {countText}
      </span>
    </div>
  );
}

